module.exports = __webpack_public_path__ + "media/images/logo-c72d955b63aa74a33e7e8c7ef542b561.jpg";